import React from "react"
import { Button } from "reactstrap"
import { useNavigate } from "react-router-dom"

const BackButton = () => {
  const navigate = useNavigate()

  const backtoHome = () => {
    navigate(-1)
  }

  return (
    <Button className="btn btn-dark" onClick={backtoHome}>
      Back
    </Button>
  )
}

export default BackButton
